import React, { useState, useEffect, useRef } from 'react';
import { $t } from '@/modules/i18n';
import { getMeta, postSubscription } from '@/modules/request';
import { Button, Modal, Toast } from 'shopee-ui-react';
import triangluarTopArrow from '@/assets/images/triangluar-top-arrow.svg';
import checkWhite from '@/assets/images/check-white.svg';
import '@/assets/scss/components/subscribe.scss';
import 'shopee-ui-react/es/theme-default/components/toast/index.css';
import 'shopee-ui-react/es/theme-default/components/select/index.css';
import 'shopee-ui-react/es/theme-default/components/modal/index.css';

const SubscribeSelect = ({ selectType = 'select', options = [], chooseValues = [], selectError = false, selectClose, setChooseValues}) => {

  const [visible, setVisible] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [chooseLabels, setChooseLabels] = useState([]);
  const [selectStyle, setSelectStyle] = useState({});
  const ref = useRef();

  const selectEvent = (event) => {
    if (ref.current.contains(event.target)) {
      return;
    }
    setVisible(false);
  }

  const swtichSelect = () => {
    setVisible(!visible);
  }

  const chooseOption = (option) => {
    const index = chooseValues.indexOf(option.value);
    if (selectType === 'multiple') {
      if (index !== -1) {
        chooseValues.splice(index, 1);
        chooseLabels.splice(index, 1);
      } else {
        chooseValues.push(option.value);
        chooseLabels.push(option.text);
      }
      setChooseValues(chooseValues);
      setChooseLabels([...chooseLabels]);
    } else {
      if (index !== -1) {
        chooseValues.pop();
        chooseLabels.pop();
        setChooseValues(chooseValues);
        setChooseLabels([...chooseLabels]);
        return;
      }
      if (chooseValues.length === 1) {
        chooseValues.pop();
        chooseLabels.pop();
      }
      chooseValues.push(option.value);
      chooseLabels.push(option.text);
      setChooseValues(chooseValues);
      setChooseLabels([...chooseLabels]);
    }
  }

  useEffect(() => {
    const { length } = options;
    setSelectStyle({
      height: `${length < 6 ? length * 38 : 6 * 38}px`
    });
  }, [options]);

  useEffect(() => {
    return () => {
      if (visible) {
        selectClose();
      }
    }
  }, [visible])

  useEffect(() => {
    document.addEventListener('click', selectEvent, false);
    return () => {
      document.removeEventListener('click', selectEvent);
    }
  }, []);

  return (
    <div ref={ref} className={selectError ? 'select select-error' : 'select'} onClick={swtichSelect}>
      <div className={!visible ? 'select-content' : 'select-content active'}>
        <span className="select-text" title={chooseLabels.map(item => $t(item)).join(', ')}>{chooseLabels.map(item => $t(item)).join(', ')}</span>
        <img src={triangluarTopArrow} className={!visible ? 'arrow' : 'arrow active'} />
      </div>
      <div style={{...selectStyle, display: visible ? 'block' : 'none'}} className="option-wrapper">
        {
          options.map(option => {
            return (
              <div className="option-item" key={option.text || option.transify_key} onClick={(e) => { e.stopPropagation(); chooseOption(option);}}>
                <div className={chooseValues.indexOf(option.value) !== -1 ? 'reat active' : 'reat'}>
                  <img style={{display: chooseValues.indexOf(option.value) !== -1 ? 'block' : 'none'}} src={checkWhite} className="check-icon"  />
                </div>
                <span style={{flex: 1}}>{$t(option.text)}</span>
              </div>
            )
          })
        }
        
      </div>
    </div>
  )
}

export default ({ visible, setModalVisible, locationList = [], levelList = [], deptList = [] }) => {
  const [value, setValue] = useState(['Option 1', 'Option 2'])

  const initForm = {
    name: '',
    email: '',
    departments: [],
    levels: [],
    regions: [],
    check: true
  }


  const [message, setMessage] = useState({
    name: '',
    email: '',
    departments: '',
    levels: '',
    regions: ''
  });
  const [form, setForm] = useState(initForm);

  useEffect(() => {
    if(visible) {
      setForm({...initForm})
    }
  }, [visible])

  const closeModal = () => {
    setModalVisible(false);
  }

  const inputFoucs = (prop) => {
    message[prop] = '';
    setMessage({
      ...message
    });
  }

  const setFormSelect = (prop, value) => {
    form[prop] = value;
    setForm({
      ...form
    });
  }

  const changeValue = (prop, event) => {
    form[prop] = event.target.value;
    setForm({
      ...form
    });
  }

  const validateAll = () => {
    let flag = true;
    Object.keys(form).forEach(item => {
      if (!validate(item, true)) flag = false;
    });
    return flag;
  }

  const validate = (prop, args) => {
    const isSubmited = !args || typeof args === 'boolean' ? args : [...args][0];
    const formItem = form[prop];
    let flag = true;
    if (prop === 'name') {
      if (formItem.trim().length === 0) {
        message.name = 'microsite_modal_subscribe_name_prompt_1';
        flag = false;
      } else if (formItem.length > 100) {
        message.name = 'microsite_modal_subscribe_name_prompt_2';
        flag = false;
      } else {
        message.name = '';
      }
    } else if (prop === 'email') {
      const parttern = /^[A-Za-z0-9][A-Za-z0-9._-]*@([a-zA-Z0-9_-]+\.)+[a-zA-Z0-9]+$/;
      if (formItem.trim().length > 100) {
        message.email = 'microsite_modal_subscribe_email_prompt_1';
        flag = false;
      } else if (formItem.trim().length === 0) {
        message.email = 'microsite_modal_subscribe_email_prompt_2';
        flag = false;
      } else if (!parttern.test(formItem)) {
        message.email = 'microsite_modal_subscribe_email_prompt_3';
        flag = false;
      } else {
        message.email = '';
      }
    } else if (prop === 'departments') {
      if (formItem.length === 0) {
        message.departments = 'microsite_modal_subscribe_dept_prompt_1';
        flag = false;
      } else {
        message.departments = '';
      }
    } else if (prop === 'regions') {
      if (formItem.length === 0) {
        message.regions = 'microsite_modal_subscribe_location_prompt_1';
        flag = false;
      } else {
        message.regions = '';
      }
    } else if (prop === 'levels') {
      if (formItem.length === 0) {
        message.levels = 'microsite_modal_subscribe_level_prompt_1';
        flag = false;
      } else {
        message.levels = '';
      }
    } else if (prop === 'check') {
      if (!formItem) flag = false;
    }
    setMessage({
      ...message
    });

    return flag;
  }

  const handleSubmit = async () => {
    if (!validateAll()) {
      return;
    }
    const level = form.levels;
    const Subscription = {
      name: form.name.trim(),
      email: form.email.trim(),
      department_list: form.departments,
      location_list: form.regions,
      level: level[0]
    };
    try {
      const res = await postSubscription(Subscription);
      if (res.code === 0) {
        Toast.success($t('microsite_toast_subscribe_success'));
        closeModal();
      } else {
        Toast.warning($t('microsite_toast_subscribe_fail'));
      }
    } catch(e) {
      Toast.warning($t('microsite_toast_subscribe_fail'));
    }
  }
  return (
    <Modal
      className="subscribe-container"
      visible={visible}
      onCancel={closeModal}
      showConfirm={false}
      showCancel={false}
      width={900}
      title={$t('microsite_modal_subscribe_title')}
    >
      <div className="form-container">
        <div className="form-item">
          <div className="label-container">
            <span className={message.name === '' ? 'label' : 'label-error'}>{$t('microsite_modal_subscribe_form_label_1')}</span>
            <span style={{color: '#EE2C4A'}}> *</span>
          </div>
          <input 
            onFocus={() => inputFoucs('name')} 
            onChange={(e) => {changeValue('name', e); validate('name')}} 
            className={message.name === '' ? null : 'input-error'} 
            onBlur={() => validate('name')} 
            type="text" />
          {
            message.name ? <div className="message">{$t(message.name)}</div> : null
          }
        </div>
        <div className="form-item">
          <div className="label-container">
            <span className={message.email === '' ? 'label' : 'label-error'}>{$t('microsite_modal_subscribe_form_label_2')}</span>
            <span style={{color: '#EE2C4A'}}> *</span>
          </div>
          <input 
            onFocus={() => inputFoucs('email')} 
            onChange={(e) => {changeValue('email', e)}} 
            className={message.email === '' ? null : 'input-error'} 
            onBlur={() => validate('email')} 
            type="text" />
          {
            message.email ? <div className="message">{$t(message.email)}</div> : null
          }
        </div>
        <div className="form-item">
          <div className="label-container">
            <span className={message.departments === '' ? 'label' : 'label-error'}>{$t('microsite_modal_subscribe_form_label_3')}</span>
            <span style={{color: '#EE2C4A'}}> *</span>
          </div>
          <SubscribeSelect
            selectType='multiple'
            selectError={message.departments !== ''}
            chooseValues={form.departments}
            setChooseValues={(value) => {setFormSelect('departments', value); validate('departments');}}
            selectClose={() => validate('departments')}
            options={deptList} />
          {
            message.departments ? <div className="message">{$t(message.departments)}</div> : null
          }
        </div>
        <div className="form-item">
          <div className="label-container">
            <span className={message.levels === '' ? 'label' : 'label-error'}>{$t('microsite_modal_subscribe_form_label_4')}</span>
            <span style={{color: '#EE2C4A'}}> *</span>
          </div>
          <SubscribeSelect
            selectError={message.levels !== ''}
            chooseValues={form.levels}
            setChooseValues={(value) => {setFormSelect('levels', value); validate('levels');}}
            selectClose={() => validate('levels')}
            options={levelList} />
          {
            message.levels ? <div className="message">{$t(message.levels)}</div> : null
          }
        </div>
        <div className="form-item">
          <div className="label-container">
            <span className={message.regions === '' ? 'label' : 'label-error'}>{$t('microsite_modal_subscribe_form_label_5')}</span>
            <span style={{color: '#EE2C4A'}}> *</span>
          </div>
          <SubscribeSelect
            selectType='multiple'
            selectError={message.regions !== ''}
            chooseValues={form.regions}
            setChooseValues={(value) => {setFormSelect('regions', value); validate('regions');}}
            selectClose={() => validate('regions')}
            options={locationList} />
          {
            message.regions ? <div className="message">{$t(message.regions)}</div> : null
          }
        </div>
        <div className="form-item"></div>
        <div className="bottom-info">
          <span onClick={() => {form.check = !form.check; setForm({...form});}} className="info-container">
            <div className={form.check ? 'reat active' : 'reat'}>
              <img src={checkWhite} className="check-icon" style={{display: form.check ? 'block' : 'none'}}/>
            </div>
            <span className="text">{$t('microsite_modal_subscribe_text_message')}</span>
          </span>
        </div>

        <div className="submit-container">
          <Button disabled={!form.check} onClick={handleSubmit} className={form.check ? 'submit-button' : 'submit-button gray'}>{$t('microsite_modal_btn_submit')}</Button>
        </div>
      </div>  
    </Modal>
  )
}
